import React, { FunctionComponent, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: ReactNode;
};

function getExportContainer(name: string, display?: 'inline' | 'block'): FunctionComponent<Props> {
  return function ExportContainer({ children }: Props): React.ReactPortal | null {
    const [isInDocument, setIsInDocument] = React.useState<boolean>(false);

    useEffect(() => {
      if (name) {
        checkInDocument();
      }
    }, [name]);

    const checkInDocument = () => {
      const el = document.querySelector(`#${name}_export_content`);
      if (el) {
        setIsInDocument(true);
        return;
      }
      setIsInDocument(false);
    };

    if (!isInDocument) {
      return null;
    }

    const el = document.querySelector(`#${name}_export_content`);

    if (display === 'inline') {
      el.classList.add('inline-flex', 'gap-4');
    }

    if (!el) {
      return null;
    }

    return createPortal(children, el);
  };
}

export { getExportContainer };
